import { render, staticRenderFns } from "./orderform.vue?vue&type=template&id=0ea37975&scoped=true&"
import script from "./orderform.vue?vue&type=script&lang=js&"
export * from "./orderform.vue?vue&type=script&lang=js&"
import style0 from "./orderform.vue?vue&type=style&index=0&id=0ea37975&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea37975",
  null
  
)

export default component.exports